import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { Row, Card, Col, Button } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { Bug, Check2Square, HouseCheck, LayoutTextWindow, Link45deg, Tools } from "react-bootstrap-icons";
import BihamtaTable from "../../Components/BihamtaTable";
import { faBan, faCalendarCheck, faFlagCheckered, faPaperPlane, faStop, faStopCircle, faUserClock, faWrench } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getServiceIDByNumber, getServiceReferListForAgentPanel } from "../store/api/Services";
import ModalProductBugs from '../Components/ModalProductBugs';
import ModalActiveGuaranteeCard from '../Components/ModalActiveGuaranteeCard';
import { downloadFile,  setErrorDialog, useIsMobileApp } from '../../store/api/CommonFunctions';
import { useDispatch } from 'react-redux';
export default function AgentPanel() {

    const history = useHistory();
    const dispatch = useDispatch();
const isMobile = useIsMobileApp();
    const searchServiceInfo = useRef({ ServiceType: "install" });
    const [serviceReferList, setServiceReferList] = useState();
    const [modalActiveCard, setModalActiveCard] = useState({ show: false });
    const [searchServicePending, setSearchServicePending] = useState(false);
    const [modalProductBugs, setModalProductBugs] = useState({ show: false });
    const dashboardTableCols = [
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: true },
        { colName: "DocumentNumber", colTitle: "شماره سرویس", showInMobile: true },
        { colName: "DocumentDate", colTitle: "تاریخ پذیرش", showInMobile: true },
        { colName: "PDocumentType", colTitle: "نوع سرویس" , showInMobile: true},
        { colName: "Status", colTitle: "وضعیت سرویس" },
        { colName: "ProductNameAndModel", colTitle: "مشخصات محصول" },
        { colName: "CustomerName", colTitle: "مشتری" }
    ]
    const rejectedTableCols = [
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: true },
        { colName: "DocumentNumber", colTitle: "شماره سرویس", showInMobile: true },
        { colName: "DocumentDate", colTitle: "تاریخ پذیرش", showInMobile: true },
        { colName: "PDocumentType", colTitle: "نوع سرویس", showInMobile: true },
        { colName: "Status", colTitle: "وضعیت سرویس" },
        { colName: "ProductNameAndModel", colTitle: "مشخصات محصول" },
        { colName: "CustomerName", colTitle: "مشتری" },
        { colName: "RejectDesc", colTitle: "دلیل رد" }
    ]
    const stoppedTableCols = [
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: true },
        { colName: "DocumentNumber", colTitle: "شماره سرویس", showInMobile:true },
        { colName: "DocumentDate", colTitle: "تاریخ پذیرش", showInMobile:true },
        { colName: "PDocumentType", colTitle: "نوع سرویس", showInMobile: true },
        { colName: "Status", colTitle: "وضعیت سرویس" },
        { colName: "ProductNameAndModel", colTitle: "مشخصات محصول" },
        { colName: "CustomerName", colTitle: "مشتری" },
        { colName: "StopDesc", colTitle: "دلیل توقف" }
    ]
    const noticeTableColes = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "تاریخ اطلاعیه", colName: "PNoticeDate", showInMobile: true },
        { colTitle: "موضوع اطلاعیه", colName: "NoticeSubject", showInMobile: true },
        { colTitle: "شرح اطلاعیه", colName: "NoticeDesc", showInMobile: false, colType: "string", maxTextLength: 128, hasTooltip: true },
        { colTitle: "ثبت کننده", colName: "CreateByName" }
    ]
    const noticeTableRowButtons = [
        {
            title: "فایل پیوست", type: "common", className: "group-Btn-smalll btn-secondary",
            icon: <Link45deg className="rowBtn" size={20} color="blue" />, tooltip: "فایل پیوست(برای باز شدن در تب جدید کلید ctrl را نگه دارید)",
            onclick: (item) => downloadFile(item.ID, "Notice", item?.e?.ctrlKey),
            showCondition: (item) => Number(item.AttachmentID) > 0
        },
    ]
    const serviceTablesRowBtn =[];
    if(isMobile)
    {
        serviceTablesRowBtn.push({
                      title: "نمایش سرویس", type: "common", className: "group-Btn-smalll btn-secondary",
            icon: <Link45deg className="rowBtn" size={20} color="blue" />,
            onclick: (item) => showService(item),  
        })
    }
    function showService(service) {
        history.push(`/Services/Service/${service.DocumentID}/${service.DocumentHardCode}`, null);
    }
    function showModalbugs() {
        setModalProductBugs({ show: true });
    }
    function showModalActiveCard() {
        setModalActiveCard({ show: true });
    }
    function searchService(e) {
        if (searchServicePending || (searchServiceInfo.current.InvoiceNumber??"") === "") {
            return;
        }
        if (e?.key && e.key !== "Enter") {
            return;
        }
        setSearchServicePending(true);
        const onGet = (res) => {
            if (res.Data) {
                history.push(`/Services/Service/${res.Data}/${searchServiceInfo.current.ServiceType}`, null);
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "جستجوی سرویس");
            }
            setSearchServicePending(res === "PENDING");
        }
        getServiceIDByNumber(searchServiceInfo.current.ServiceType, searchServiceInfo.current.InvoiceNumber, onGet);
    }
    useEffect(() => {
        document.body.classList = "";
        getServiceReferListForAgentPanel(setServiceReferList);
    }, []);
    return (
        <div>
            <div className="container-fluid mt-1">
                <ModalProductBugs popData={modalProductBugs} setPopData={setModalProductBugs} />
                <ModalActiveGuaranteeCard popData={modalActiveCard} setPopData={setModalActiveCard} />
                <Row className="mt-1" style={{ margin: 0 }}>
                    <Col md={2} sm={6} xs={6} className='mt-1'>
                        <Button variant="warning" className="group-Btn" style={{ height: "100%", width: "100%" }}
                            onClick={showModalbugs}>
                            <Bug size={25} style={{ display: "block", width: "100%" }} className="mb-1" />
                            <span style={{ fontSize: "14px" }}>
                                فهرست ایرادات
                            </span>
                        </Button>
                    </Col>
                    <Col md={2} sm={6} xs={6} className='mt-1'>
                        <Button variant="info" className="group-Btn" style={{ height: "100%", width: "100%" }}
                            onClick={showModalActiveCard}>
                            <Check2Square size={25} style={{ display: "block", width: "100%" }} className="mb-1" />
                            <span style={{ fontSize: "14px" }}>
                                استعلام گارانتی
                            </span>
                        </Button>
                    </Col>
                    <Col md={2} sm={6} xs={6} className='mt-1'>
                        <Button className="group-Btn" style={{ height: "100%", width: "100%" }}
                            onClick={() => history.push("/Services/PartRequest/0")}>
                            <LayoutTextWindow size={25} style={{ display: "block", width: "100%" }} className="mb-1" />
                            <span style={{ fontSize: "14px" }}>
                                درخواست قطعه
                            </span>
                        </Button>
                    </Col>
                    <Col md={2} sm={6} xs={6} className='mt-1'>
                        <Button variant="secondary" className="group-Btn" style={{ height: "100%", width: "100%" }}
                            onClick={() => history.push(`/Services/Service/0/install`, null)}>
                            <HouseCheck size={25} style={{ display: "block", width: "100%" }} className="mb-1" />
                            <span style={{ fontSize: "14px" }}>
                                نصب جدید
                            </span>
                        </Button>
                    </Col>
                    <Col md={2} sm={6} xs={6} className='mt-1'>
                        <Button variant="secondary" className="group-Btn" style={{ height: "100%", width: "100%" }}
                            onClick={() => history.push(`/Services/Service/0/repair`, null)}>
                            <Tools size={25} style={{ display: "block", width: "100%" }} className="mb-1" />
                            <span style={{ fontSize: "14px" }}>
                                تعمیر جدید </span>
                        </Button>
                    </Col>
                    <Col md={2} sm={6} xs={6} className='mt-1'>
                        <Button variant="secondary" className="group-Btn" style={{ height: "100%", width: "100%" }}
                            onClick={searchService} disabled={searchServicePending}>
                            <div>
                                <input className='tableRowInput' style={{ display: "inline-block", width: "60%" }} onClick={e => e.stopPropagation()}
                                    onChange={e => searchServiceInfo.current.InvoiceNumber = e.target.value} placeholder='شماره سرویس' onKeyDown={searchService} />
                                <select className='tableRowInput' style={{ display: "inline-block", width: "40%" }} onClick={e => e.stopPropagation()}
                                    onChange={e => searchServiceInfo.current.ServiceType = e.target.value}>
                                    <option value="install">نصب</option>
                                    <option value="repair">تعمیر</option>
                                </select>
                            </div>
                            <span style={{ fontSize: "14px" }}>
                                جستجوی سرویس </span>

                        </Button>
                    </Col>
                </Row>
                <Row xs={1} md={3} className="g-4 mt-1" style={{justifyContent:"center"}}>
                    <Col md={6} style={{ height: "420px" }}                >
                        <Card style={{ padding: 0, height: "100%" }}>
                            <Card.Header style={{ color: "black", border: "none", backgroundColor: "#4e7493" }}>
                                <Card.Title style={{ color: "white" }}>
                                    <FontAwesomeIcon icon={faWrench} size="lg" color="white" />
                                    &nbsp;&nbsp;
                                    سرویس های در حال تکمیل
                                </Card.Title>
                            </Card.Header>
                            <Card.Body style={{ overflow: "auto", padding: "2px" }} className="scThin">
                                <BihamtaTable rowButtons={serviceTablesRowBtn} columns={dashboardTableCols} dataList={{ Data: serviceReferList?.Data?.inProcess }} className="mt-0 mb-0  "
                                    style={{ whiteSpace: "noWrap" }} maxHeight={360}
                                    rowClick={showService} searchable={true} />
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={6} style={{ height: "420px" }}>
                        <Card style={{ background: "rgb(246 246 247)", color: "white", height: "100%" }}>
                            <Card.Header style={{ background: "#ae3c47" }}>
                                <Card.Title><FontAwesomeIcon icon={faStopCircle} size="lg" />&nbsp;سرویس های متوقف شده</Card.Title>
                            </Card.Header >
                            <Card.Body>
                                <BihamtaTable rowButtons={serviceTablesRowBtn} columns={stoppedTableCols} dataList={{ Data: serviceReferList?.Data?.stopped }} className="mt-0 mb-0  " style={{ whiteSpace: "noWrap" }}
                                    rowClick={showService} searchable={true} maxHeight={500} />
                            </Card.Body>
                        </Card>
                    </Col>                    
                    <Col md={6} style={{ height: "420px" }}>
                        <Card style={{ height: "100%", background: "rgb(246 246 247)" }}>
                            <Card.Header style={{ background: "#d58054" }}>
                                <Card.Title style={{ display: "inline-block", color: "white" }}>
                                    <FontAwesomeIcon icon={faBan} size="lg" />&nbsp;
                                    <Link to="" style={{ color: "white" }}>سرویس های رد شده</Link>
                                </Card.Title>
                            </Card.Header>
                            <Card.Body style={{ overflow: "auto", minHeight: "505px", height: "505px" }} className="scThin">
                                <BihamtaTable rowButtons={serviceTablesRowBtn} columns={rejectedTableCols} dataList={{ Data: serviceReferList?.Data?.rejected }} className="mt-0 mb-0  " style={{ whiteSpace: "noWrap" }}
                                    searchable={true} maxHeight={360} />
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={6} style={{ height: "420px" }}>
                        <Card style={{ background: "rgb(246 246 247)", color: "white", height: "100%" }}>
                            <Card.Header style={{ background: "#5a67b3" }}>
                                <Card.Title>
                                    <FontAwesomeIcon icon={faPaperPlane} size="lg" />&nbsp;
                                    <span className="cardTitle">سرویس های ارسالی به دفتر مرکزی</span>
                                </Card.Title>
                                <div className="sepLine"></div>
                            </Card.Header>

                            <Card.Body>
                                <BihamtaTable rowButtons={serviceTablesRowBtn} columns={dashboardTableCols} dataList={{ Data: serviceReferList?.Data?.done ?? "PENDING" }} className="mt-0 mb-0  " style={{ whiteSpace: "noWrap" }}
                                     searchable={true} maxHeight={500} />
                            </Card.Body>

                        </Card>
                    </Col>
                    <Col md={6} style={{ height: "420px" }}>
                        <Card style={{ background: "rgb(246 246 247)", color: "white", height: "100%" }}>
                            <Card.Header style={{ background: "#5a8fb3" }}>
                                <Card.Title>
                                    <FontAwesomeIcon icon={faFlagCheckered} size="lg" />&nbsp;
                                    <span className="cardTitle">اطلاعیه های من</span>
                                </Card.Title>
                                <div className="sepLine"></div>
                            </Card.Header>
                            <Card.Body>
                                <BihamtaTable columns={noticeTableColes} rowButtons={noticeTableRowButtons} dataList={{ Data: serviceReferList?.Data?.noticeList ?? "PENDING" }}
                                    hasPaging={true} />
                            </Card.Body>
                        </Card>

                    </Col>
                </Row>
            </div>
        </div>

    )

}